import React, { useEffect } from "react";
import Checkbox from "../../../components/core/form-components/Checkbox";
import Paragraph from "../../../components/core/typography/Paragraph";
import Button from "../../../components/core/form-components/Button";
import { useFormikContext } from "formik";
import { LanguageTranslation } from "../../../components/language-translation/LanguageTranslation";

interface colorInterface {
  id: number;
  hexcode: string;
  name: string;
}

interface ColorPickerModalProps {
  open: boolean;
  onClose?: () => void;
  colorOptions: any;
  id: any;
  selectedColors: colorInterface[];
  langId?: string;
}

function ColorPickerModal({
  open,
  onClose,
  colorOptions,
  id,
  selectedColors,
  langId,
}: ColorPickerModalProps) {
  const { values, setFieldValue } = useFormikContext<{
    mainColor: colorInterface | null;
    secondaryColor: colorInterface | null;
    selectedColors: colorInterface[];
  }>();

  const colorOptionss = colorOptions?.colors.map(
    (color: { id: number; name: string; hexcode: string }) => ({
      ...color,
      label:
        LanguageTranslation({
          labelName: `color_${color.id}`,
          languageCode: langId ?? "fr",
        }) || color.name,
    })
  );

  useEffect(() => {
    if (selectedColors?.length > 0) {
      setFieldValue("selectedColors", selectedColors);
      setFieldValue("mainColor", selectedColors[0] || null);
      setFieldValue("secondaryColor", selectedColors[1] || null);
    }
  }, [id, selectedColors]);

  const handleCheckboxChange = (color: colorInterface) => {
    let newSelectedColors = [...(values.selectedColors || [])];

    if (newSelectedColors.some((selected) => selected.id === color.id)) {
      newSelectedColors = newSelectedColors.filter(
        (selected) => selected.id !== color.id
      );
    } else if (newSelectedColors.length < 2) {
      newSelectedColors = [...newSelectedColors, color];
    } else {
      alert("You can only select up to 2 colors.");
      return;
    }

    setFieldValue("selectedColors", newSelectedColors);
    setFieldValue("mainColor", newSelectedColors[0] || null);
    setFieldValue("secondaryColor", newSelectedColors[1] || null);
  };

  return (
    <div>
      <Paragraph text20 className="font-medium mb-2">
        {LanguageTranslation({
          labelName: "colourimetry",
          languageCode: langId ?? "fr",
        }) || "Colourimetry"}
      </Paragraph>
      <Paragraph text16 className="!text-dark-grey mb-3">
        {LanguageTranslation({
          labelName: "colourimetry_note",
          languageCode: langId ?? "fr",
        }) || "Note: You can select a maximum of two colors."}
      </Paragraph>
      <ul className="flex flex-col gap-4">

        {colorOptionss?.map((color: any) => (
          <li className="inline-flex" key={color.id}>
            <Checkbox
              w18
              name={"colourimetry"}
              id={`color-${color.id}`}
              value={color.id.toString()}
              checked={(values.selectedColors || []).some(
                (selected) => selected.id === color.id
              )}
              onChange={() => handleCheckboxChange(color)}
              disabled={
                (values.selectedColors || []).length >= 2 &&
                !(values.selectedColors || []).some(
                  (selected) => selected.id === color.id
                )
              }
            >
              <div className="flex items-center gap-2">
                <span
                  className="w-5 h-5 rounded-full block border border-medium-grey"
                  style={{ background: color.hexcode }}
                ></span>
                {color?.label}
              </div>
            </Checkbox>
          </li>
        ))}
      </ul>
      <div className="flex gap-3 mt-[34px]">
        <Button onClick={onClose} borderButton className="mb-2">
          {LanguageTranslation({
            labelName: "cancel",
            languageCode: langId ?? "fr",
          }) || "Cancel"}
        </Button>
        <Button onClick={onClose} primary className="mb-2">
          {LanguageTranslation({
            labelName: "ok",
            languageCode: langId ?? "fr",
          }) || "OK"}
        </Button>
      </div>
    </div>
  );
}

export default ColorPickerModal;
